exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.scheduleTypeHolder button[data-v-ad6c5ade] {\n  line-height: normal;\n  height: 80px;\n  width: 160px;\n  margin-right: 0.5rem;\n}\n.scheduleTypeHolder button.selected[data-v-ad6c5ade] {\n    border-color: #00a9f0;\n    border-width: 2px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-ad6c5ade","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/tools/modal/EventEdit/areaRulesPax.vue
// module id = 1433
// module chunks = 0